import { Component, OnInit, Renderer2, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ActivityTabs, BookingBehavior } from '../shared/constants/commonenums';
import { BookingActivity , ClassType, LessonTypes} from '../shared/Models/SessionBookingDTO';
import { operationType, LanguageFileName } from '../shared/Models/WidgetSettingsModels';
import { GuestService } from '../shared/services/guest.service';
import { PopupService } from '../shared/services/popup.service';
import { ActivitiesService } from './activities.service';
import { DynamicFormService } from '../shared/dynamicform/service/dynamic-form.service';

@Component({
  selector: 'app-activities',
  templateUrl: './activities.component.html',
  styleUrls: ['./activities.component.scss']
})
export class ActivitiesComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  outOfServiceMessage: any;
  restaurantId: any;
  SelectedTab = 0;
  propertyLocation: string;
  isDataLoaded: boolean = false;
  acceptReservation = false;
  ComponentTab = ActivityTabs;
  bookAnotherReservation = false;
  bookingSection = 1;
  BookingType = BookingActivity;
  backgroundImageData:any;
  OperationCurrency:string;

  constructor(public activityService: GuestService, private renderer: Renderer2, private router: Router, private route: ActivatedRoute, private ts: TranslateService,  public ps: PopupService,public dfs:DynamicFormService) {

    this.subscriptions.add(this.activityService.TabChange$.subscribe(data => {
      this.SelectedTab = data;
    }));

    this.subscriptions.add(this.activityService.bookingSection$.subscribe(data => {
      this.bookingSection = data;
    }))
    this.subscriptions.add(this.activityService.BookAnotherReservation.subscribe(data => {
      if (data === true) {
        this.bookAnotherReservation = data;
        this.getRestaurantWidgetSettings();
      }
    }))
    this.activityService.restaurantWidgetName = this.route.snapshot.params.restaurantName;
  }

  ngOnInit(): void {
    this.getRestaurantWidgetSettings();
  }

  loadDataRetentionPolicy() {
    if (this.activityService.restaurantWidgetSettings$.value.IsGDPREnabled) {
      this.subscriptions.add(this.activityService.GetRestaurantPolicy(this.activityService.restaurantWidgetSettings$.value.RestaurantId).subscribe(data => {
        if (data) {
          this.activityService.fromclient = this.route.snapshot.queryParams["client"] == "yes" ? true : false;
          this.activityService.dataRetentionPolicy$.next(data);
        }
      }));
    }
  }

  loadRestaurantSettings(data) {
    if(data?.OperationCurrency ){
      this.OperationCurrency = data.OperationCurrency
    }
    this.activityService.restaurantWidgetSettings$.next(data);
    this.activityService.widgetSettings = data;
    this.ps.restaurantWidgetSettings$.next(data);
    this.acceptReservation = data.AcceptsReservations && !data.DisableReservations;
    if (this.acceptReservation) {
      this.activityService.addGoogleTagManager(data.WidgetCustomization.GTMCode);
      this.activityService.restaurantWidgetName = data.RestaurantName;
      this.activityService.restaurantWidgetId = data.RestaurantId;
      if (this.activityService.restaurantWidgetSettings$.value.WidgetCustomization.AllowTableSelection) {
        this.activityService.getRestaurantImages(this.activityService.restaurantWidgetSettings$.value.RestaurantId);
      }

      this.subscriptions.add(this.activityService.GetCustomFields(data.RestaurantId).subscribe(data => {
        this.activityService.customGuestFields = data;
      }));

      this.subscriptions.add(this.activityService.GetCountries().subscribe(data => {
        this.activityService.countriesList = data;
        this.dfs.countriesList = data
      }))

      if (this.activityService.operation == operationType.create) {
        this.loadDataRetentionPolicy();
      }
    }
    else {
      const propertyName = data.PropertyType === this.activityService.ConfigSettings.defaultPropertyName ? this.activityService.ConfigSettings.defaultPropertyName : this.activityService.ConfigSettings.generalPropertyName;
      this.ts.get('notAcceptOnlineWebReservation', {propertyName: propertyName, restaurantName: data.RestaurantName, phoneNumber: data.phoneNumber}).subscribe(result => {
        this.outOfServiceMessage= {message : result};
      });
    }
  }

  loadClassActivities(data) {
    let ActivitiesList = [];
    this.activityService.LocationList = data.Locations;
    this.activityService.InstructorList = data.Instructors;
    this.activityService.AllocationTypes = data.AllocationMappings;
    const AllLessons = data.AvailableSpecialMeals;
    AllLessons.forEach(lesson => {
      let activity = {}
      let locationval = [];
      let staffval = [];
      lesson.ActivitySessions.forEach(session => {
        session.SessionLocationMappings?.forEach(location => {
          if ((locationval && locationval.length == 0) || locationval.length > 0 && !locationval.find(x => x.LocationId == location.StandaloneTableId))
            locationval.push({ 'LocationName': this.getLocation(location), 'LocationId': location.StandaloneTableId });

        });
        session.SessionStaffMappings?.forEach(staff => {
          if ((staffval && staffval.length == 0) || staffval.length > 0 && !staffval.find(x => x.ServerId == staff.ServerId))
            staffval.push({ 'ServerId': staff.ServerId, 'StaffName': this.getInstructor(staff) });

        });
      });

      locationval = locationval?.sort((a, b) => (a.LocationName > b.LocationName) ? 1 : ((b.LocationName > a.LocationName) ? -1 : 0))
      lesson['LocationName'] = locationval?.map(function (elem) {
        return elem.LocationName;
      }).join(",");
      lesson['Staffs'] = staffval?.filter(x => x).map(function (elem) {
        return elem.StaffName;
      }).join(",");
      lesson['LessonName'] = lesson.Name;
      lesson['LocationId'] = locationval;
      lesson['StaffValues'] = staffval;
      lesson['SpecialMealId'] = lesson.Id;
      lesson['SpecialMealId'] = lesson.Id;
      // Not considering available slots count
      lesson['Availability'] = lesson.ClassType == ClassType.Class && !(lesson.AvailableSlots > 0) ? 'Not Available' : 'Available';
      lesson['isViewable'] = locationval.length && staffval.length || false;
      ActivitiesList.push(lesson);
    });
    ActivitiesList = ActivitiesList.filter(x => x.isViewable);
    this.activityService.allClassActivitiesAvailable$.next(ActivitiesList);
    this.activityService.bookingSection$.next(BookingActivity.ClassBooking);
  }

  UniqueArrayOfObject(array, FirstkeyToBeUnique, SecondKeyToBeUnique) {
    return array.filter((data, index) => !array.slice(index + 1)
      .some(y => y[FirstkeyToBeUnique] === data[FirstkeyToBeUnique] && y[SecondKeyToBeUnique] === data[SecondKeyToBeUnique]));
  }


  getLocation(location) {
    let loc = this.activityService.LocationList.filter(data => data.Id === location.StandaloneTableId);
    return (loc && loc.length > 0) ? loc[0].Name : '';

  }

  getInstructor(staffdata) {
    const staff = this.activityService.InstructorList.filter(data => data.Id === staffdata.ServerId)[0];
    if (staff) {
      return staff.Name + ' ' + (staff.LastName || '');
    }
    else {
      return '';
    }
  }

  getRestaurantWidgetSettings() {

    if (this.route.snapshot.params.pageName && this.route.snapshot.params.restaurantName) {

      this.subscriptions.add(this.activityService.getWidgetSettingsByRestaurantName(this.activityService.restaurantWidgetName).subscribe(data => {
        if (data) {
          this.activityService.bookingSection$.next(BookingActivity.ClassBooking)
          if(data?.OperationCurrency ){
            this.OperationCurrency = data.OperationCurrency
          }
          this.activityService.restaurantWidgetSettings$.next(data);
          this.ps.restaurantWidgetSettings$.next(data);
          this.loadDataRetentionPolicy();
         // this.activityService.loadLanguageData(data);
          this.isDataLoaded = true;
          if (this.bookAnotherReservation) {
            this.activityService.filterAvailabilities.next(true);
          }
        }
        else {
          this.outOfServiceMessage= {message : this.activityService.ConfigSettings.commonErrorMessage};
        }
      }));

    } else if (this.route.snapshot.params.restaurantName) {
      this.activityService.restaurantWidgetName = this.route.snapshot.params.restaurantName;
      this.subscriptions.add(this.activityService.getWidgetSettingsByRestaurantName(this.activityService.restaurantWidgetName).subscribe(data => {
        if (data) {

          const CartList = JSON.parse(sessionStorage.getItem('CartList'));
          this.activityService.cartCount = CartList ? CartList.length : 0
          const crypto = window.crypto;
          var array = new Uint32Array(1);
          this.activityService.CartBookingList$.next(crypto.getRandomValues(array));
          this.activityService.bookingSection$.next(BookingActivity.ClassBooking)
          this.activityService.globaactivityServiceeatingAreaId = this.route.snapshot.queryParams["section_id"];
          this.loadRestaurantSettings(data);
       //   this.activityService.loadLanguageData(data);
          this.loadClassActivities(data);
          this.loadBackgroundImage(data.RestaurantId);
          this.isDataLoaded = true;
          if (this.bookAnotherReservation) {
            this.activityService.filterAvailabilities.next(true);
          }
        }
        else {
          this.outOfServiceMessage= {message :this.activityService.ConfigSettings.commonErrorMessage};
        }
      }));

    }
    else if (this.route.snapshot.params.restaurantToken) {
      if (!this.bookAnotherReservation) {
        this.restaurantId = this.route.snapshot.params.restaurantId;
        this.activityService.reservationToken = this.route.snapshot.params.restaurantToken;
        this.activityService.operation = this.route.snapshot.params.operation == "edit" ? operationType.edit : this.route.snapshot.params.operation == "cancel" ? operationType.cancel : operationType.create;
        this.activityService.language = Number(LanguageFileName[this.route.snapshot.params.language.toLowerCase().toString()]);
        this.activityService.byPassValidation = true;
        this.subscriptions.add(this.activityService.getByToken(this.activityService.reservationToken, '', this.route.snapshot.params.bookingType).subscribe(reservation => {
          this.activityService.byPassValidation = false;
          if (reservation) {
            if (!Array.isArray(reservation)) {
              this.restaurantId = reservation.RestaurantId;
            } else {
              this.restaurantId = reservation[0].RestaurantId
            }
            this.subscriptions.add(this.activityService.getWidgetSettingsByRestaurantId(this.restaurantId).subscribe(data => {
              if (data) {
                this.loadRestaurantSettings(data);
                this.loadClassActivities(data);
                this.loadBackgroundImage(data.RestaurantId);
                let LessonType = 0;
                if(data.AvailableSpecialMeals && data.AvailableSpecialMeals.length > 0 && reservation.SpecialMealId) {
                  let specialMeal = data.AvailableSpecialMeals.find(meal => meal.Id == reservation.SpecialMealId )
                  if(specialMeal){
                    LessonType = specialMeal.LessonType;
                  }
                }
                if (!Array.isArray(reservation) && reservation.SpecialMealId && LessonType == LessonTypes.GroupLesson) {
                  this.activityService.editPartyData$.next(reservation);
                  const specialMeal = data.AvailableSpecialMeals.filter(x => x.Id === reservation.SpecialMealId)[0];
                  this.activityService.bookingSection$.next(BookingActivity.ClassBooking);
                  if (this.activityService.operation === operationType.edit) {
                    this.SelectedTab = ActivityTabs.ActivitySelection;
                    this.activityService.TabChange$.next(ActivityTabs.ActivitySelection)
                  } else {
                    this.SelectedTab = ActivityTabs.ConfirmationSummary;
                    this.activityService.TabChange$.next(this.SelectedTab)
                  }
                  this.activityService.SelectedActivity$.next(specialMeal);
                } else {
                  if (Array.isArray(reservation)) {
                    this.activityService.editPartyData$.next(reservation[0]);
                    this.activityService.bookingPartiesData$.next(reservation);
                  } else {
                    this.activityService.editPartyData$.next(reservation);
                    this.activityService.bookingPartiesData$.next([reservation]);
                  }
                  this.activityService.bookingSection$.next(BookingActivity.OpenBooking);
                  this.SelectedTab = ActivityTabs.ConfirmationSummary;
                  this.activityService.TabChange$.next(this.SelectedTab)
                }
                this.isDataLoaded = true;
                if (this.bookAnotherReservation) {
                  this.activityService.filterAvailabilities.next(true);
                }
              }
              else {
                this.outOfServiceMessage= {message : this.activityService.ConfigSettings.commonErrorMessage};
              }

            }));
          }
          else {
            //this.outOfServiceMessage = this.activityService.ConfigSettings.commonErrorMessage;
            this.outOfServiceMessage= {message : this.ts.instant('cannotProcessRequest')};
          }
        }));
      }
    }
    else {

      this.outOfServiceMessage = {message : this.activityService.ConfigSettings.commonErrorMessage};
    }
  }


  loadBackgroundImage(restaurantId){
    this.subscriptions.add(this.activityService.getBackgroundImage(restaurantId).subscribe(response=>{
      if(response){
        this.backgroundImageData = response.Payload;
        this.setbackgroundImage();
      }
    }))
  }
  setbackgroundImage(){
    let mainContainer = document.getElementsByClassName('main-container');
    if (this.backgroundImageData && mainContainer) {
      this.renderer.setStyle(mainContainer[0], 'background-image', 'url(data:image/png;base64,'+this.backgroundImageData +')');
      this.renderer.setStyle(mainContainer[0], 'background-repeat', 'no-repeat');
      this.renderer.setStyle(mainContainer[0], 'background-size', 'cover');
      this.renderer.setStyle(mainContainer[0], 'background-position', 'center');
    } else {
      this.renderer.setStyle(mainContainer[0],'background',this.activityService.restaurantWidgetSettings$.value.WidgetCustomization.WidgetBackgroundColor);
    }
  }
  // getting data from common header

  closeMessage(event) {
    this.activityService.setMessageState('', 0);
  }
  ngOnDestroy(): void {
    if (this.subscriptions) { this.subscriptions.unsubscribe(); }
  }
}
